import { render } from "./App.vue?vue&type=template&id=0b6658a6&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0b6658a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\96450\\Desktop\\gea\\testvue3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6658a6"]])

export default __exports__